<div class="unstyled-table__row" role="row">
    <div class="unstyled-table__cell" role="cell">
        {{ 'loan.payment_per_month' | translate }}
    </div>
    <div class="unstyled-table__cell" role="cell">
        <span class="loan__detail-value-wrapper">
            <span class="loan__detail-value">{{ loanData.paymentPerMonth | defaultcurrency }}</span>
        </span>
    </div>
</div>
<div class="unstyled-table__row" role="row">
    <div class="unstyled-table__cell" role="cell">
        {{ 'loan.down_payment' | translate }}
    </div>
    <div class="unstyled-table__cell" role="cell">
        <span class="loan__detail-value-wrapper">
            <span class="loan__detail-value">{{ loanData.downPayment | defaultcurrency }}</span>
        </span>
    </div>
</div>
<div class="unstyled-table__row" role="row">
    <div class="unstyled-table__cell" role="cell">
        {{ 'loan.base_amount' | translate }}
    </div>
    <div class="unstyled-table__cell" role="cell">
        <span class="loan__detail-value-wrapper">
            <span class="loan__detail-value">{{ loanData.baseAmount | defaultcurrency }}</span>
        </span>
    </div>
</div>
<div class="unstyled-table__row" role="row">
    <div class="unstyled-table__cell" role="cell">
        {{ 'loan.total_repay' | translate }}
    </div>
    <div class="unstyled-table__cell" role="cell">
        <span class="loan__detail-value-wrapper">
            <span class="loan__detail-value">{{ loanData.totalRepay | defaultcurrency }}</span>
        </span>
    </div>
</div>
<div class="unstyled-table__row" role="row">
    <div class="unstyled-table__cell" role="cell">
        {{ 'loan.total_loan_costs' | translate }}
    </div>
    <div class="unstyled-table__cell" role="cell">
        <span class="loan__detail-value-wrapper">
            <span class="loan__detail-value">{{ loanData.totalLoanCosts | defaultcurrency }}</span>
        </span>
    </div>
</div>
<div class="unstyled-table__row" role="row">
    <div class="unstyled-table__cell" role="cell">
        {{ 'loan.interest_type' | translate }}
    </div>
    <div class="unstyled-table__cell" role="cell">
        <span class="loan__detail-value-wrapper">
            <span class="loan__detail-value">{{ loanData.interestType }}</span>
        </span>
    </div>
</div>
<div class="unstyled-table__row" role="row">
    <div class="unstyled-table__cell" role="cell">
        {{ 'loan.aop_before_tax' | translate }}
    </div>
    <div class="unstyled-table__cell" role="cell">
        <span class="loan__detail-value-wrapper">
            <span class="loan__detail-value">{{ loanData.aopBeforeTax }} <span *ngIf="loanData.aopBeforeTax">%</span></span>
        </span>
    </div>
</div>
<div class="unstyled-table__row" role="row">
    <div class="unstyled-table__cell" role="cell">
        {{ 'loan.interest_rate' | translate }}
    </div>
    <div class="unstyled-table__cell" role="cell">
        <span class="loan__detail-value-wrapper">
            <span class="loan__detail-value">{{ loanData.interestRate }} <span *ngIf="loanData.interestRate">%</span></span>
        </span>
    </div>
</div>
<div class="unstyled-table__row" role="row">
    <div class="unstyled-table__cell" role="cell">
        {{ 'loan.nominal_interest' | translate }}
    </div>
    <div class="unstyled-table__cell" role="cell">
        <span class="loan__detail-value-wrapper">
            <span class="loan__detail-value"
                >{{ loanData.nominalInterest }} <span *ngIf="loanData.nominalInterest">%</span></span
            >
        </span>
    </div>
</div>